import dayjs from 'dayjs';
import { TranslateFunc, FormatDateFunc } from '@ha/intl';

import { DateRange } from './types';
import { NO_END } from './constants';

export default function getAvailablityLabel(
  bookablePeriods: DateRange[],
  T: TranslateFunc,
  formatDate: FormatDateFunc,
): string {
  if (!bookablePeriods.length) {
    return T('Unavailable');
  }

  const startDate = bookablePeriods[0].from;
  const endDate = bookablePeriods[0].to;

  let start = formatDate('D MMM YYYY', startDate);
  let end = formatDate('D MMM YYYY', endDate);

  if (dayjs().isAfter(startDate) && dayjs().isBefore(endDate)) {
    start = T('Now');
  }

  if (dayjs(endDate).isSame(NO_END)) {
    end = T('Unlimited');
  }

  return `${start} - ${end}`;
}
